import { Action, createReducer, on } from '@ngrx/store';
import * as OrientationActions from 'src/app/travelxnew/store/actions/orientations.actions';
import { OrientationsState } from 'src/app/travelxnew/store/state/orientations.state';

export const orientationStoreFeatureKey = 'orientations';

export const initialState: OrientationsState = {
    loading: false,
    contracts: [],
    selectedContract: null,
    error: undefined,
    expandedSectionState: {},
    overview: null,
    overviewLoading: false,
    compliance: null,
    complianceLoading: false,
    payroll: null,
    payrollLoading: false,
    housing: null,
    housingLoading: false,
    benefit: null,
    benefitLoading: false,
    facility: null,
    facilityLoading: false
};

const reducer = createReducer(
    initialState,

    on(OrientationActions.getOrientationContractsByCandidateId, (state) => ({
        ...state,
        loading: true
    })),

    on(OrientationActions.getOrientationContractsByCandidateIdSuccess, (state, action) => ({
        ...state,
        contracts: action.contracts,
        loading: false
    })),

    on(OrientationActions.getOrientationContractsByCandidateIdFailure, (state, action) => ({
        ...state,
        contracts: [],
        error: action.error,
        loading: false
    })),

    on(OrientationActions.setSelectedContract, (state, action) => {
        const contract = state.contracts.find((c) => c.id === action.contractId);
        return {
            ...state,
            selectedContract: contract ?? null
        };
    }),

    on(OrientationActions.clearSelectedContract, (state) => ({
        ...state,
        selectedContract: null
    })),

    on(OrientationActions.updateOrientationStatus, (state) => ({
        ...state,
        loading: true
    })),

    on(OrientationActions.updateOrientationStatusSuccess, (state) => ({
        ...state,
        loading: false
    })),

    on(OrientationActions.updateOrientationStatusFailure, (state, action) => ({
        ...state,
        error: action.error,
        loading: false
    })),

    on(OrientationActions.setSectionExpandedState, (state, action) => {
        const newExpandedState = { ...state.expandedSectionState };

        newExpandedState[action.section] = action.state;
        return {
            ...state,
            expandedSectionState: newExpandedState
        };
    }),

    on(OrientationActions.getOrientationOverview, (state) => ({
        ...state,
        overview: state.overview,
        overviewLoading: true
    })),

    on(OrientationActions.getOrientationOverviewSuccess, (state, action) => ({
        ...state,
        overview: action.overview,
        overviewLoading: false
    })),

    on(OrientationActions.getOrientationOverviewFailure, (state, action) => ({
        ...state,
        overview: null,
        error: action.error,
        overviewLoading: false
    })),

    on(OrientationActions.getOrientationCompliance, (state) => ({
        ...state,
        compliance: state.compliance,
        complianceLoading: true
    })),

    on(OrientationActions.getOrientationComplianceSuccess, (state, action) => ({
        ...state,
        compliance: action.compliance,
        complianceLoading: false
    })),

    on(OrientationActions.getOrientationComplianceFailure, (state, action) => ({
        ...state,
        compliance: null,
        error: action.error,
        complianceLoading: false
    })),

    on(OrientationActions.getOrientationPayroll, (state) => ({
        ...state,
        payroll: state.payroll,
        payrollLoading: true
    })),

    on(OrientationActions.getOrientationPayrollSuccess, (state, action) => ({
        ...state,
        payroll: action.payroll,
        payrollLoading: false
    })),

    on(OrientationActions.getOrientationPayrollFailure, (state, action) => ({
        ...state,
        payroll: null,
        error: action.error,
        payrollLoading: false
    })),

    on(OrientationActions.getOrientationHousing, (state) => ({
        ...state,
        housing: state.housing,
        housingLoading: true
    })),

    on(OrientationActions.getOrientationHousingSuccess, (state, action) => ({
        ...state,
        housing: action.housing,
        housingLoading: false
    })),

    on(OrientationActions.getOrientationHousingFailure, (state, action) => ({
        ...state,
        housing: null,
        error: action.error,
        housingLoading: false
    })),

    on(OrientationActions.getOrientationBenefits, (state) => ({
        ...state,
        benefit: state.benefit,
        benefitLoading: true
    })),

    on(OrientationActions.getOrientationBenefitsSuccess, (state, action) => ({
        ...state,
        benefit: action.benefit,
        benefitLoading: false
    })),

    on(OrientationActions.getOrientationBenefitsFailure, (state, action) => ({
        ...state,
        benefit: null,
        error: action.error,
        benefitLoading: false
    })),

    on(OrientationActions.getOrientationFacility, (state) => ({
        ...state,
        facility: state.facility,
        facilityLoading: true
    })),

    on(OrientationActions.getOrientationFacilitySuccess, (state, action) => ({
        ...state,
        facility: action.facility,
        facilityLoading: false
    })),

    on(OrientationActions.getOrientationFacilityFailure, (state, action) => ({
        ...state,
        facility: null,
        error: action.error,
        facilityLoading: false
    }))
);

export function orientationsReducer(state: OrientationsState | undefined, action: Action) {
    return reducer(state, action);
}
